class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.details = this.closest("details");
    this.summary = this.details.querySelector("summary");

    this._resetHeight();

    // Bind event handlers
    this.onClick = this.onClick.bind(this);
    this.onResize = this.onResize.bind(this);

    // bind onclick to summary element
    this.summary.addEventListener("click", this.onClick);

    // Listen for window resize event
    window.addEventListener("resize", this.onResize);
  }

  _open() {
    this.details.setAttribute("data-opening", "true");
    this.details.setAttribute("open", "true");

    this.details.style.height = `${
      this.summary.scrollHeight + this.scrollHeight
    }px`;
  }

  _resetHeight() {
    this.details.style.height = `${this.summary.scrollHeight}px`;
  }

  _close() {
    this.details.removeAttribute("data-opening");
    this.details.setAttribute("data-closing", "true");

    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.removeAttribute("data-closing");
    }, 300);

    this.details.style.height = `${this.summary.scrollHeight}px`;
  }

  onClick(e) {
    e.preventDefault();
    if (!this.details.open) {
      this._open();
    } else {
      this._close();
    }
  }

  onResize() {
    if (this.details.open) {
      this.details.style.height = `${
        this.summary.scrollHeight + this.scrollHeight
      }px`;
    } else {
      this._resetHeight();
    }
  }

  // Clean up event listener when element is removed from the DOM
  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }
}

if (!customElements.get("accordion-element")) {
  customElements.define("accordion-element", AccordionElement);
}

class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute("data-variant-id");
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

  async onClick(e) {
    e.preventDefault();
    const res = await fetch("/cart/add", {
      method: "post",
      body: new URLSearchParams({
        id: this.variantId,
        quantity: 1,
      }),
    });

    // update cart
    const cartDrawer = document.getElementById("cart");

    cartDrawer.update();
    cartDrawer.openDrawer();
  }
}

if (!customElements.get("quick-add")) {
  customElements.define("quick-add", QuickAddToCart);
}

class SizeChart extends HTMLElement {
  constructor() {
    super();

    console.log("sizing....", this.getAttribute("data-size-chart"));

    const rawSizeChart = this.getAttribute("data-size-chart") || "[]";
    this.sizeChart = [];
    this.singleValue = null;

    try {
      const parsed = JSON.parse(rawSizeChart);
      if (Array.isArray(parsed)) {
        this.sizeChart = parsed;
      } else {
        this.singleValue = `${parsed}`.trim();
      }
    } catch (e) {
      this.singleValue = `${rawSizeChart}`.trim();
    }

    // Create a shadow DOM for encapsulation
    const shadow = this.attachShadow({ mode: "open" });

    // Apply styles and add the table to the shadow DOM
    const style = document.createElement("style");
    style.textContent = `
      * {
      font-family: "Basic Commercial", sans-serif;
      font-style: normal;
      font-weight: 400;

      text-align: left;
      }

      .table-header,
      .table-header th {
      text-transform: lowercase;
      }

      table {
      width: 100%;
      outline: 0;
      border-collapse: collapse;
      }

      th, td {
      width: 1%;
      font-size: 14px;
      }

      th {
        padding-bottom: 4px;
      }

      td {
        padding: 4px 0;
      }

      tr:last-child td {
        padding-bottom: 0;
      }

      .break {
      height: 0.5px;
      background-color: #D1D1D1;
      }

    `;

    // Generate the table and append it to the shadow DOM
    const content = this.singleValue
      ? this.generateSingleValue()
      : this.generateTable();
    shadow.appendChild(style);
    shadow.appendChild(content);
  }

  // Method to generate the table based on JSON data
  generateTable() {
    const table = document.createElement("table");

    // Create headers from the first item in the data array
    if (this.sizeChart.length > 0) {
      const headers = Object.values(this.sizeChart[0]);
      const thead = document.createElement("thead");
      thead.classList.add("table-header");

      const headerRow = document.createElement("tr");
      headers.forEach((headerText) => {
        const th = document.createElement("th");
        th.textContent = headerText;
        headerRow.appendChild(th);
      });

      thead.appendChild(headerRow);
      table.appendChild(thead);

      // Create table body with data
      const tbody = document.createElement("tbody");
      this.sizeChart.slice(1).forEach((rowData) => {
        const row = document.createElement("tr");

        Object.values(rowData).forEach((cellData) => {
          const cell = document.createElement("td");
          cell.textContent = cellData;

          const cellValue = `${cellData}`.trim();
          const isInteger = /^-?\d+$/.test(cellValue);
          const numericValue = parseInt(cellValue, 10);

          if (isInteger && numericValue >= 1 && numericValue <= 9) {
            cell.classList.add("text-gray-500");
          }

          row.appendChild(cell);
        });

        tbody.appendChild(row);
      });
      table.appendChild(tbody);
    }

    return table;
  }

  generateSingleValue() {
    const container = document.createElement("div");
    container.textContent = this.singleValue;

    const isInteger = /^-?\d+$/.test(this.singleValue);
    const numericValue = parseInt(this.singleValue, 10);

    if (isInteger && numericValue >= 1 && numericValue <= 9) {
      container.classList.add("text-gray-500");
    }

    return container;
  }
}

// Define the custom element if it’s not already defined
if (!customElements.get("size-chart")) {
  customElements.define("size-chart", SizeChart);
}

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);

    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    // get the menu button
    this.menuButton = this.querySelector("button[id='menu-button']");
    this.mobileMenu = this.querySelector("nav[id='mobile-menu']");
    this.closeButton = this.querySelector("button[id='close']");
    this.menuBg = this.querySelector("div[id='bg-menu']");

    console.log(this.menuButton);

    // bind the click event

    this.closeButton.addEventListener("click", this.onClick);
    this.menuButton.addEventListener("click", this.onClick);
  }

  onClick(e) {
    e.preventDefault();

    if (this.hasAttribute("open")) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    this.mobileMenu.setAttribute("open", "true");
    this.setAttribute("open", "true");
    document.body.classList.add("overflow-hidden", "h-screen");
  }

  closeMenu() {
    this.removeAttribute("open");
    this.mobileMenu.removeAttribute("open");
    document.body.classList.remove("overflow-hidden", "h-screen");
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}

class CartItem extends HTMLElement {
  constructor() {
    super();
    // bind click event to button id decrease
    this.decreaseButton = this.querySelector("button[id='decrease']");
    this.increaseButton = this.querySelector("button[id='increase']");
    this.quantity = parseInt(this.querySelector("p[id='quantity']")?.innerHTML);

    this.pid = this.getAttribute("data-product-id");
    this.handleQuantity = this.handleQuantity.bind(this);
    console.log(this.quantity);
    if (this.decreaseButton)
      this.decreaseButton.addEventListener("click", this.handleQuantity);
    if (this.increaseButton)
      this.increaseButton.addEventListener("click", this.handleQuantity);
  }

  async handleQuantity(e) {
    console.log(e.target.id);
    if (e.target.id === "decrease") {
      if (parseInt(this.quantity) === 1) {
        console.log("too low");
      }
      if (parseInt(this.quantity) > 1) {
        document
          .querySelector("cart-drawer")
          .updateQuantity(this.pid, this.quantity - 1);
        console.log("decrease it by 1 bro");
      }
    }
    if (e.target.id === "increase") {
      document
        .querySelector("cart-drawer")
        .updateQuantity(this.pid, this.quantity + 1);
    }
    e.preventDefault();
    console.log(this.pid, this.quantity);
  }
}

if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.openDrawer = this.openDrawer.bind(this);
    this.update = this.update.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  async connectedCallback() {
    this.freebieElements = this.querySelectorAll("#freebies div");
    document.addEventListener("click", this.onClick);

    await this.clearFreebies();
    await this.update();

    // Add event listener for DOMContentLoaded to clear freebies on page load
    document.addEventListener(
      "DOMContentLoaded",
      this.clearFreebies.bind(this)
    );
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onClick);
  }

  onClick(e) {
    if (e.target.id === "cart") {
      e.preventDefault();
      this.closeDrawer();
      return;
    }

    const closeBtn = e.target.closest("#close-cart, #close");
    if (closeBtn) {
      e.preventDefault();
      this.closeDrawer();
    }
  }

  async update() {
    await this.updateFreeItems();

    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const cartDrawer = document.getElementById("cart");
    if (cartDrawer) {
      cartDrawer.innerHTML = html.querySelector("#cart").innerHTML;
    }

    await this.updateHeaderCartCount();
  }

  async updateHeaderCartCount() {
    let headerCart = document.querySelector("header-cart");
    if (!headerCart) return;

    // Ensure the custom element definition is loaded before calling its methods
    await customElements.whenDefined("header-cart");
    headerCart = document.querySelector("header-cart");
    if (!headerCart || typeof headerCart.setCount !== "function") return;

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      headerCart.setCount(cart.item_count || 0);
    } catch (error) {
      console.error("Error updating header cart count:", error);
    }
  }

  async updateFreeItems() {
    if (this.freebieElements.length === 0) {
      return;
    }

    const res = await fetch("/cart.js");
    const cart = await res.json();

    for (const element of this.freebieElements) {
      const threshold = parseInt(element.getAttribute("data-threshold"), 10);
      const productId = parseInt(element.getAttribute("data-product-id"), 10);
      const freebieItem = cart.items.find((item) => item.id === productId);

      if (cart.total_price < threshold * 100) {
        // Remove the freebie from the cart if it's there
        if (freebieItem) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: freebieItem.key,
              quantity: 0,
            }),
          });
        }
      } else {
        // Add the freebie to the cart if it's not already there
        if (!freebieItem) {
          await this.addProductToCart(productId, true);
        }
      }
    }
  }

  async updateQuantity(itemId, quantity) {
    await fetch("/cart/change", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemId,
        quantity: quantity,
      }),
    })
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    // Update the cart drawer after the quantity change
    await this.update();
  }

  async addProductToCart(itemId, freeItem = false) {
    console.log("adding product to cart", itemId);
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: itemId,
            quantity: 1,
            properties: freeItem ? { _freeItem: "True" } : {},
          },
        ],
      }),
    })
      .catch((error) => {
        console.error("Error:", error);
      })
      .then(() => {
        this.update();
      });
  }

  async addToCart(form) {
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    })
      .then(async (res) => {
        console.log("added!");
        this.openDrawer();
        await this.update();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // looks for a freebie in cart, and removes any
  async clearFreebies({ route = true } = {}) {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    let updates = {};

    // goes through the cart items and collects freebies
    cart.items.forEach(async (item) => {
      if (item.properties && item.properties._promo === "Freebie") {
        updates[item.id] = 0;
      }
      if (route && item.vendor === "Route") {
        updates[item.id] = 0;
        console.log("route!");
      }
    });

    // removes the freebies from the cart
    await fetch("/cart/update", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: updates,
      }),
    }).catch((error) => {
      console.error("Error:", error);
    });
  }

  async addFreebiesToCart(itemIds, discountCode) {
    try {
      // 1. Clear existing freebies
      await this.clearFreebies({ route: false });

      // 2. Add new freebies
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: itemIds.map((id) => ({
            id: id,
            quantity: 1,
            properties: { _promo: "Freebie" },
          })),
        }),
      });

      // 3. Apply discount via AJAX
      if (discountCode) {
        const discountResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            discount: discountCode,
          }),
        });

        const discountData = await discountResponse.json();
        if (discountData && discountData.items) {
          console.log("Discount applied:", discountCode, discountData);
        } else {
          console.warn("Discount could not be applied");
        }
      }

      // 4. Redirect to checkout

      window.location.href = `/checkout`;
    } catch (error) {
      console.error("Error in addFreebiesToCart:", error);
    }
  }

  openDrawer() {
    document.getElementById("freebie-select-screen").style.display = "none";
    document.getElementById("drawer").style.display = "flex";

    this.setAttribute("open", "true");
    document.body.style.overflow = "hidden";
  }

  async closeDrawer() {
    this.removeAttribute("open");
    document.body.style.overflow = "auto";

    await this.clearFreebies();
    await this.update();
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button[id='atc']");
    this.quickCheckout = this.querySelector("button[id='quick-checkout']");
    this.onClick = this.onClick.bind(this);

    this.onClickQuickCheckout = this.onClickQuickCheckout.bind(this); // Bind the method

    if (this.quickCheckout)
      this.quickCheckout.addEventListener("click", this.onClickQuickCheckout);

    this.button.addEventListener("click", this.onClick);

    this.variants = this.querySelectorAll("div[id='variant']");
    this.setInitialVariant();
    this.activeVariant = this.activeVariant.bind(this);
    this.variants.forEach((variant) => {
      variant.addEventListener("click", (e) => {
        this.activeVariant(e);
      });
    });
  }

  setInitialVariant() {
    let activeVariant = this.querySelector("input[id='selected-variant-id']");
    this.variants.forEach((variant) => {
      if (variant.getAttribute("data-variant-id") === activeVariant.value) {
        variant.classList.add("selected");
      }
    });
  }

  async activeVariant(e) {
    let activeVariant = this.querySelector("input[id='selected-variant-id']");
    // highlight the selected variant
    this.variants.forEach((variant) => {
      variant.classList.remove("selected");
    });
    e.target.classList.add("selected");
    activeVariant.value = e.target.getAttribute("data-variant-id");
  }
  // Export custom element
  async onClickQuickCheckout(e) {
    e.preventDefault();
    console.log(this);
    let activeVariant = this.querySelector("#selected-variant-id").value;
    console.log("active variant is", activeVariant);

    let checkoutLink = `/cart/${activeVariant}:1`;
    window.open(checkoutLink, "_self");
  }

  async onClick(e) {
    e.preventDefault();
    const form = this.closest("form");
    // add data attribute "loading" for two seconds
    let loader = this.querySelector("span[id='loading']");
    let active = this.querySelector("span[id='active']");
    if (loader) {
      // remove hidden
      loader.classList.remove("hidden");
      active.classList.add("hidden");
    }
    setTimeout(() => {
      if (loader) {
        loader.classList.add("hidden");
        active.classList.remove("hidden");
      }
    }, 2000);

    document.querySelector("cart-drawer").addToCart(form);
    // open cart drawer with id cart (add style display fleex)
  }
}

if (!customElements.get("cart-add")) {
  customElements.define("cart-add", AddToCart);
}

class HeaderCart extends HTMLElement {
  constructor() {
    super();
    this.countEl = this.querySelector("[data-cart-count]");
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

  setCount(count) {
    if (!this.countEl) return;
    const normalizedCount = Number.isNaN(parseInt(count, 10)) ? 0 : count;
    this.countEl.textContent = `(${normalizedCount})`;
  }

  onClick(e) {
    e.preventDefault();
    document.querySelector("cart-drawer").openDrawer();
  }
}

if (!customElements.get("header-cart")) {
  customElements.define("header-cart", HeaderCart);
}


// Turn into a more abstracted component for the drawer
class RemoveButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }
  async onClick(e) {
    e.preventDefault();
    console.log(e.target.href);

    const form = this.closest("form");

    await fetch(e.target.href, {
      method: "post",
      body: new FormData(form),
    });
    console.log("remove it bro");
    document.querySelector("cart-drawer").update();
  }
}

if (!customElements.get("remove-button")) {
  customElements.define("remove-button", RemoveButton);
}

class Newsletter extends HTMLElement {
  constructor() {
    super();
    // elements are input with id email, button with id subscribe
    this.email = this.querySelector("input[id='email']");
    this.button = this.querySelector("button[id='subscribe']");
    this.onClick = this.onClick.bind(this);
    console.log(this.button);

    // if ?customer_posted=true#contact_form is in the url, show a success message
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get("customer_posted");
    if (customerPosted === "true") {
      this.changeStatus("Thank you for subscribing");
    }
    this.button.addEventListener("click", this.onClick);
  }
  async onClick(e) {
    console.log(this.email.value);
    if (this.email.value.length < 5) {
      this.changeStatus("Please enter a valid email ");
    }
    // alert('yeas')
  }

  async changeStatus(text) {
    this.querySelector("p").textContent = text;
  }
}

if (!customElements.get("newsletter")) {
  customElements.define("newsletter-widget", Newsletter);
}

class SlideShow extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }

  initSwiper() {
    // Make sure Swiper only initializes when the swiper-container is present
    const swiperContainer = this;
    console.log(swiperContainer);
    if (swiperContainer) {
      const swiper = new Swiper(".swiper", {
        // Swiper options
        slidesPerView: 1, // Number of slides to show
        spaceBetween: 0, // Space between slides
        speed: 400,
        on: {
          init: this.updateProgressBar.bind(this), // Reference to class method
          slideChange: this.updateProgressBar.bind(this), // Reference to class method
        },
      });
      console.log(swiper);
    }
  }
  updateProgressBar() {
    this.querySelector("div[id='progress']").style.width = `${
      ((this.swiper.activeIndex + 1) / this.swiper.slides.length) * 100
    }%`;

    console.log(this.swiper.activeIndex + 1, this.swiper.slides.length);
  }
}

if (!customElements.get("product-slideshow")) {
  customElements.define("product-slideshow", SlideShow);
}

class SearchWidget extends HTMLElement {
  constructor() {
    super();
    this.searchPlaceholder = this.querySelector("#search-placeholder");
    this.searchInput = this.querySelector("#search");

    // Bind the event handlers
    this.toggleSearch = this.toggleSearch.bind(this);
    this.executeSearch = this.executeSearch.bind(this);

    // Click to show search input
    this.searchPlaceholder.addEventListener("click", this.toggleSearch);

    // Listen for Enter key in the input field
    this.searchInput.addEventListener("keydown", this.executeSearch);
  }

  toggleSearch() {
    this.searchPlaceholder.classList.add("hidden");
    this.searchInput.classList.remove("hidden");
    this.searchInput.focus();
  }

  executeSearch(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const query = this.searchInput.value.trim();

      if (query.length > 0) {
        // Redirect to the Shopify search page with the search query
        window.location.href = `/search?q=${encodeURIComponent(
          query
        )}&type=product`;
      }
    }
  }
}

// Define the custom element
if (!customElements.get("search-widget")) {
  customElements.define("search-widget", SearchWidget);
}
class MenuSearchWidget extends HTMLElement {
  constructor() {
    super();

    this.placeholder = this.querySelector("#menu-search-placeholder");
    this.input = this.querySelector("#menu-search");

    if (!this.placeholder || !this.input) return;

    this.toggleSearch = this.toggleSearch.bind(this);
    this.executeSearch = this.executeSearch.bind(this);

    this.placeholder.addEventListener("click", this.toggleSearch);
    this.input.addEventListener("keydown", this.executeSearch);
  }

  toggleSearch() {
    this.placeholder.classList.add("hidden");
    this.input.classList.remove("hidden");
    this.input.focus();
  }

  executeSearch(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const query = this.input.value.trim();
      if (!query) return;

      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    }
  }
}

if (!customElements.get("menu-search-widget")) {
  customElements.define("menu-search-widget", MenuSearchWidget);
}
